module.exports = __webpack_public_path__ + "static/media/w_w_hb_18.5ad07c0b.png";